export default __webpack_public_path__ + "static/media/search_icon.8a26a48e.svg";